import en from './en.json';
import hy from './hy.json';
import ru from './ru.json';

const modules = { en, hy, ru };

export default modules;
